import { Table } from "antd";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { FormatCurrency } from "../../common/Constants";

export const ExpiredTable = ({ ExpiredCases, ExpiredSummary, pagePermission }) => {
    const navigate = useNavigate();

    const columns = [
        {
            title: "Application ID",
            dataIndex: "application_uniqueId",
            key: "application_uniqueId",
            width: 150,
            render: (text, record) => (
                <div className="make-model-block">
                    <p>{`${text}`}</p>
                    <h2>{`${record?.dealer_info?.name}`}</h2>
                    <p>{`${record?.ongoing_data?.disbursement_date}`}</p>
                </div>
            ),
        },
        {
            title: "Flooring Type",
            dataIndex: "flooring_product",
            key: "flooring_product",
            width: 130,
            render: (flooring_product) => (
                <div className="table-info-block">
                    <span>{flooring_product}</span>
                </div>
            ),
        },
        {
            title: "Veh/Chassis No",
            dataIndex: "vehicle_reg_no",
            key: "vehicle_reg_no",
            width: 140,
            render: (vehicle_reg_no, item) => (
                <div className="ven-block">
                    <h2>{`${vehicle_reg_no}`}</h2>
                    <p>{`${item.chassis_no}`}</p>
                </div>
            ),
        },
        {
            title: "Make/Model",
            dataIndex: "make_model",
            key: "make_model",
            width: 150,
            render: (make_model) => (
                <div className="make-model-block">
                    <h2>{`${make_model}`}</h2>
                </div>
            ),
        },
        {
            title: "Int. per 30 days",
            dataIndex: "ongoing_data",
            key: "ongoing_data",
            width: 90,
            render: (ongoing_data) => (
                <div>
                    <span>{FormatCurrency(ongoing_data?.agent_interest_rate)}%</span>
                </div>
            ),
        },
        {
            title: "Floor Amt.",
            dataIndex: "ongoing_data",
            key: "ongoing_data",
            width: 100,
            render: (ongoing_data) => (
                <div>
                    <span>${FormatCurrency(ongoing_data?.intended_floor_amount)}</span>
                </div>
            ),
        },
        {
            title: "Admin Fee",
            dataIndex: "ongoing_data",
            key: "ongoing_data",
            width: 100,
            render: (ongoing_data) => (
                <div>
                    <span>${FormatCurrency(ongoing_data?.agent_admin_fee)}</span>
                </div>
            ),
        },
        {
            title: "Total Int. Till Date",
            dataIndex: "ongoing_data",
            key: "ongoing_data",
            width: 100,
            render: (ongoing_data) => (
                <div>
                    <span>${FormatCurrency(ongoing_data?.total_interest)}</span>
                </div>
            ),
        },
        {
            title: "Total Amt.  Paid",
            dataIndex: "ongoing_data",
            key: "ongoing_data",
            width: 100,
            render: (TotalAmtPaid) => (
                <div>
                    <span>${FormatCurrency(TotalAmtPaid?.total_amount_paid)}</span>
                </div>
            ),
        },
        {
            title: "Redemption Amt.",
            dataIndex: "ongoing_data",
            key: "ongoing_data",
            width: 110,
            render: (RedemptionAmt) => (
                <div>
                    <span>${FormatCurrency(RedemptionAmt?.redemption_amount)}</span>
                </div>
            ),
        },
        {
            title: "Action",
            dataIndex: "OngoingAction",
            key: "OngoingAction",
            width: 100,
            render: (action, item) => (
                <div>
                    <span
                        className="view-resume-block"
                        onClick={() => {
                            navigate("/flooring-cases/view", {
                                state: {
                                    appId: item?.id,
                                    submitted_date: item?.submitted_date,
                                    expiry_date: item?.expiry_date,
                                    isOngoing: true,
                                    pagePermission: pagePermission
                                },
                            });
                        }}
                    >
                        <EyeOutlined className="mt-1" />
                        <span>View</span>
                    </span>
                    {pagePermission?.delete_permission == 1 && (
                        <span
                            className="table-delete-block"
                            onClick={() => {
                                //console.log("click delete");
                            }}
                        >
                            <DeleteOutlined className="mt-1" />
                            <span>Delete</span>
                        </span>
                    )}
                </div>
            ),
        },
    ];

    return (
        <Table
            dataSource={ExpiredCases}
            columns={columns}
            scroll={{ x: "calc(700px + 50%)", y: 500 }}
        />
    );
};
